import React, {Component} from 'react';

import {withUser} from '../lib/user';
import ErrorScreen from '../screens/ErrorScreen';
import BugsnagClient from '../components/BugSnagClient';

const ErrorBoundary = BugsnagClient.getPlugin('react').createErrorBoundary(React)

function setUser(signedIn, user) {
  if (signedIn) {
    BugsnagClient.setUser(user.id, user.email, user.userName);
    BugsnagClient.addMetadata("company", {id: user.company.id, name: user.company.name });
  }
  else {
    BugsnagClient.setUser('', '', '');
    BugsnagClient.clearMetadata();
  }
}

class BugsnagComponent extends Component {
  componentDidMount() {
    const {signedIn, user} = this.props;
    setUser(signedIn, user);
  }

  componentDidUpdate() {
    const {signedIn, user} = this.props;
    setUser(signedIn, user);
  }

  render() {
    return (
      <ErrorBoundary
        FallbackComponent={ErrorScreen} >
        {this.props.children}
      </ErrorBoundary>
    );
  }
}

export default withUser(BugsnagComponent);
